import { useNavigate, useParams } from 'react-router-dom';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { sanitiseKimQuestion } from '@/helpers/sanitiseKimQuestion';

interface FollowUpQuestionsProps {
  followUpQuestions?: string[];
}

export function FollowUpQuestions({ followUpQuestions }: FollowUpQuestionsProps) {
  const { matterId, subsetId } = useParams();
  if (!matterId || !subsetId) return;

  const navigate = useNavigate();

  // Old Kim is read-only — follow-up questions are asked in the new Kim experience instead
  const askInNewKim = (value: string) => {
    const question = sanitiseKimQuestion(value);
    trackCustomEvent(TrackingEventsV2.ThreadFollowUpQuestion);
    navigate(
      `/matters/${matterId}/subsets/${subsetId}/new-kim?question=${encodeURIComponent(question)}&autoSubmit=true`,
    );
  };

  const hasNoContent = !followUpQuestions || followUpQuestions?.length === 0;

  if (hasNoContent) {
    return null;
  }

  return (
    <>
      <div className="mx-2 mt-4 mb-2 flex items-center gap-3">
        <span className="iconify lucide--message-circle-question mb-0.5 size-5 text-teal-500" />

        <h2 className="text-sm font-semibold text-gray-800">Follow up questions</h2>
      </div>

      <div className="flex flex-col gap-2 rounded-md p-2">
        {followUpQuestions.map((question) => (
          <div className={`rounded px-2 py-1 hover:bg-gray-100`} key={question}>
            <div>
              <button
                className="flex w-full items-center justify-between gap-4 rounded py-1 text-left text-sm"
                onClick={() => askInNewKim(question)}
              >
                <p className="text-xs">{question}</p>

                <span className="iconify lucide--arrow-right h-4 w-4 shrink-0 text-teal-500" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
